/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {GlobalProps, setGlobalProps} from '@ion/dls/src/props/GlobalPropsConfig';

/**
 * Initializes the `GlobalPropConfig` with props of interest to the BMW Web
 * Portal Application and it's application specific values.
 *
 * The `GlobalProps` are set during module initialization, thus, this module
 * need only be imported by a single module during pre-initialization, generally
 * the `src/store/actions/initialization.ts` module.
 *
 * ```typescript
 *   // /src/store/actions/initialization.ts
 *   ...
 *   import from '../../props';
 * ```
 *
 * @see {@link GlobalProps}
 * @see {@link setGlobalProps}
 */
setGlobalProps({
  'Application.Name' : 'BMW Web Portal'
} as GlobalProps);
